module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-36-e9f250e1094c69400c284e642089be8d.jpg";